import { Directive, Input, ElementRef, HostListener } from '@angular/core';

import { DropdownMenuComponent } from './dropdown-menu.component';

@Directive({
  selector: '[artemisDropdownToggler]',
  exportAs: 'dropdownToggler'
})
export class DropdownTogglerDirective {

  @Input('artemisDropdownToggler') set dropdown(dropdownElement: DropdownMenuComponent) {
    this.dropdownElement = dropdownElement;
    this.dropdownOpened = this.dropdownElement.dropdownOpened;
  }

  private dropdownOpened: boolean = false;

  dropdownElement: DropdownMenuComponent;

  @HostListener('document:click', ['$event']) onClick($event: any) {
    if (!this.dropdownOpened && ($event.target === this.togglerElement.nativeElement ||
                                 this.togglerElement.nativeElement.contains($event.target))) {
      this.toggleDropdown(true);
    } else if (this.dropdownOpened &&
               (!this.dropdownElement.elRef.nativeElement.querySelector('[keepMenuOpenItem]') ||
                !this.dropdownElement.elRef.nativeElement.querySelector('[keepMenuOpenItem]').contains($event.target))) {
        this.toggleDropdown(false);
    }
  }

  constructor(private togglerElement: ElementRef) { }

  toggleDropdown(value: boolean): void {
    this.dropdownOpened = value;
    this.dropdownElement.toggleDropdown(value);
  }
}
